module.exports = __webpack_public_path__ + "assets/img/self-train-split.4ff0728d.svg";